import React, { Component } from "react";
import { PageHeader, Descriptions, Tag, Spin, Table, Card } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../../../../Components/Items";

moment.locale("es");

const tipoLabel = (tipo) => {
  if (tipo === "facturaCompleta") return <Tag color="purple">Factura Completa</Tag>;
  if (tipo === "insumoFactura") return <Tag color="cyan">Insumo de Factura</Tag>;
  if (tipo === "insumoCompleto") return <Tag color="geekblue">Insumo Completo</Tag>;
  return <Tag>{tipo}</Tag>;
};

class VerProrrateo extends Component {
  state = {
    loading: false,
    prorrateo: null,
    facturaOrigen: null,
    facturaObjetivo: null,
    ordenDeCompraObjetivo: null,
    usuario: null,
    poliza: null,
  };

  componentDidMount() {
    this.cargarDatos();
  }

  cargarDatos() {
    const id = this.props.location.state?.id;
    if (!id) return;
    this.setState({ loading: true });
    axios
      .post(
        "prorrateo/datosProrrateo",
        { empresaId: this.props.empresaId, prorrateoId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            prorrateo: res.data.prorrateo,
            facturaOrigen: res.data.facturaOrigen,
            facturaObjetivo: res.data.facturaObjetivo,
            ordenDeCompraObjetivo: res.data.ordenDeCompraObjetivo,
            usuario: res.data.usuario,
            poliza: res.data.poliza,
          });
        }
      });
  }

  render() {
    const { loading, prorrateo, facturaOrigen, facturaObjetivo, ordenDeCompraObjetivo, usuario, poliza } = this.state;

    const columnsInsumos = [
      { title: "Clave", dataIndex: "clave", key: "clave", width: "10%" },
      {
        title: "Descripción",
        key: "descripcion",
        ellipsis: true,
        render: (_, r) => r.descripcion || r.stringBuscar || "",
      },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        key: "cantidad",
        align: "right",
        width: "8%",
      },
      {
        title: "Costo anterior",
        dataIndex: "costoAnterior",
        key: "costoAnterior",
        align: "right",
        width: "13%",
        render: (v) => dineroDisabledMask(v),
      },
      {
        title: "Costo adicional",
        dataIndex: "costoAdicional",
        key: "costoAdicional",
        align: "right",
        width: "13%",
        render: (v) => dineroDisabledMask(v),
      },
      {
        title: "Costo nuevo",
        dataIndex: "costoNuevo",
        key: "costoNuevo",
        align: "right",
        width: "13%",
        render: (v) => dineroDisabledMask(v),
      },
    ];

    const columnsOrigen = [
      { title: "Clave", dataIndex: "clave", key: "clave", width: "10%" },
      {
        title: "Descripción",
        key: "descripcion",
        ellipsis: true,
        render: (_, r) => r.descripcion || r.stringBuscar || "",
      },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        key: "cantidad",
        align: "right",
        width: "8%",
      },
    ];

    const nombreUsuario = usuario
      ? [usuario.nombre, usuario.apellidoPaterno, usuario.apellidoMaterno].filter(Boolean).join(" ")
      : "—";

    const polizaText = poliza
      ? `#${poliza.numeroTipoPoliza || ""} tipo ${poliza.numeroTipoTipoPoliza || ""} — ${poliza.concepto || ""}`
      : "—";

    return (
      <Spin spinning={loading}>
        <PageHeader
          title={"Prorrateo" + (prorrateo ? " #" + prorrateo.folio : "")}
          onBack={() => this.props.history.push("/panel/prorrateos")}
          tags={
            prorrateo
              ? prorrateo.estado === 1
                ? <Tag color="green">Activo</Tag>
                : <Tag color="red">Cancelado</Tag>
              : null
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        {prorrateo && (
          <div style={{ padding: "0 0 24px" }}>
            <Card size="small" style={{ marginBottom: 12 }}>
              <Descriptions size="small" column={2}>
                <Descriptions.Item label="Fecha">
                  {moment(prorrateo.fechaRegistro).format("LL")}
                </Descriptions.Item>
                <Descriptions.Item label="Tipo">{tipoLabel(prorrateo.tipo)}</Descriptions.Item>
                {prorrateo.tipo === "facturaCompleta" && (
                  <Descriptions.Item label="Método">{prorrateo.metodo}</Descriptions.Item>
                )}
                <Descriptions.Item label="Monto prorrateo">
                  {dineroDisabledMask(prorrateo.montoProrrateo)}
                </Descriptions.Item>
                <Descriptions.Item label="Factura origen">
                  {facturaOrigen
                    ? `${facturaOrigen.codigoFactura ? (facturaOrigen.codigoFactura + " — ") : ""}${facturaOrigen.proveedor?.razonSocial || ""}`
                    : "—"}
                </Descriptions.Item>
                <Descriptions.Item label={prorrateo.tipoObjetivo === "ordenDeCompra" ? "Orden de Compra objetivo" : "Factura objetivo"}>
                  {prorrateo.tipoObjetivo === "ordenDeCompra"
                    ? ordenDeCompraObjetivo
                      ? `${[ordenDeCompraObjetivo.serieOrdenCompra, ordenDeCompraObjetivo.numero].filter(Boolean).join(" ")} — ${ordenDeCompraObjetivo.proveedor?.razonSocial || ""}`
                      : "—"
                    : facturaObjetivo
                    ? `${facturaObjetivo.codigoFactura ? (facturaObjetivo.codigoFactura + " — ") : ""}${facturaObjetivo.proveedor?.razonSocial || ""}`
                    : "—"}
                </Descriptions.Item>
                <Descriptions.Item label="Usuario">{nombreUsuario}</Descriptions.Item>
                <Descriptions.Item label="Póliza">{polizaText}</Descriptions.Item>
              </Descriptions>
            </Card>

            <Card size="small" title="Insumos afectados" style={{ marginBottom: 12 }}>
              <Table
                size="small"
                dataSource={prorrateo.insumos || []}
                columns={columnsInsumos}
                rowKey={(r, i) => i}
                pagination={false}
              />
            </Card>

            {prorrateo.tipo === "insumoCompleto" && (prorrateo.insumosOrigen || []).length > 0 && (
              <Card size="small" title="Insumos de la factura de prorrateo">
                <Table
                  size="small"
                  dataSource={prorrateo.insumosOrigen}
                  columns={columnsOrigen}
                  rowKey={(r, i) => i}
                  pagination={false}
                />
              </Card>
            )}

            {prorrateo.tipo === "facturaCompleta" && (prorrateo.insumosExcluidos || []).length > 0 && (
              <Card size="small" title="Insumos excluidos del prorrateo" style={{ marginTop: 12 }}>
                <Table
                  size="small"
                  dataSource={prorrateo.insumosExcluidos}
                  columns={columnsOrigen}
                  rowKey={(r, i) => i}
                  pagination={false}
                />
              </Card>
            )}
          </div>
        )}
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(VerProrrateo);
